import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Dashboard/";

const dashboardAPIService = new APIService(baseUrl);

export async function GetInvestigatorDashboard(investigatorid) {
  var url = `getinvestigatordata?investigatorid=${investigatorid}`;
  return await dashboardAPIService.fetchData(url);
}

export async function GetCustomerDashboard(requestorid) {
  var url = `getcustomerdata?requestorid=${requestorid}`;
  return await dashboardAPIService.fetchData(url);
}

export async function GetAdminDashboard() {
  var url = "getadmindata";
  return await dashboardAPIService.fetchData(url);
}

export async function GetQADashboard(qaid) {
  var url = `getqadata?qaid=${qaid}`;
  return await dashboardAPIService.fetchData(url);
}
